import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useInvoicingSettingsHost } from '../../../contexts/invoicingSettingsHostContext'
import { invoicingSettingsSectionToTKey } from '../constants/invoicingSettingsSectionToTKey'
import type { InvoicingSettingsNavItem } from '../types/invoicingSettingsNavItem'

export const useInvoicingSettingsNavItems = (): InvoicingSettingsNavItem[] => {
  const { t } = useTranslation()
  const { visibleSections } = useInvoicingSettingsHost()

  return useMemo(
    () =>
      visibleSections.map((section) => ({
        label: t(invoicingSettingsSectionToTKey[section]),
        section,
      })),
    [t, visibleSections],
  )
}
